import { Component, effect, signal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { EventSelectorComponent } from '@event/event-selector/event-selector.component';
import { TranslatePipe } from '@ngx-translate/core';

import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'ad6-root',
  imports: [
    RouterOutlet,
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatSidenavModule,
    TranslatePipe,
    EventSelectorComponent,
    SidebarComponent,
  ],
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent {
  sidenavOpen = signal<boolean>(true);
  sidenavResizeEffect = effect(() => {
    this.sidenavOpen();
    const resizeEvent = new Event('resize');
    // Trigger resize event to make sure sidenav content is correctly sized
    window.dispatchEvent(resizeEvent);
  });

  environment = signal<string | undefined>(environment.name !== 'PRODUCTION' ? environment.name : undefined);

  onMenuButton(): void {
    this.sidenavOpen.update(value => !value);
  }
}
